<div>
  <div *ngIf="!matter_info.covered" class="float-right">
    <a href="javascript: void(0)" (click)="openStatus.emit('open_status')">
      <img [src]="matter_info.stop_sign" style="width: 80px; height: 80px" alt="STOP" />
    </a>
  </div>
  <div *ngIf="!matter_info.is_fee_agreement && !matter_info.court_appointed && !matter_info.pro_bono" class="float-right">
    <a href="javascript: void(0)" (click)="openStatus.emit('open_status')">
      <img [src]="matter_info.yield_sign" style="width: 80px; height: 80px" alt="STOP" />
    </a>
  </div>
  <div *ngIf="!matter_info.default_appoinment_address_present" class="float-right">
    <a href="javascript: void(0)" (click)="openStatus.emit('open_status')">
      <img [src]="matter_info.street_sign" style="width: 80px; height: 80px" alt="STOP" />
    </a>
  </div>
</div>
<h2 *ngIf="matter_info.is_archived" class="text-danger">ARCHIVED!</h2>
<h2 *ngIf="!matter_info.clients_present" class="text-danger">There is no client in this matter!</h2>
<h3 style="font-weight: normal">{{ matter_info.case_name }}</h3>
<strong>Matter {{ matter_info.number }}</strong>
<a *ngIf="matter_info.client_intake_id" [href]="'/client_intakes/' + matter_info.client_intake_id" class="btn btn-sm btn-link">Client Intake - #{{ matter_info.client_intake_id }}</a>
<app-badge badgeType="warning" *ngIf="!matter_info.client_intake_id">No client intake present</app-badge>
<a [href]="'/share_sessions/impersonate?matter_id=' + matter_info.id" class="btn btn-sm btn-link" target="_blank" title="Preview the client portal as this matter's client"><i class="fas fa-user-secret mr-1"></i>View as Client</a>
<br />
<p>{{ matter_info.status_full_name }}&nbsp;|&nbsp;{{ matter_info.matter_type_name }}&nbsp;|&nbsp;{{ matter_info.jurisdiction }}</p>
<div *ngIf="matter_info.has_donors">
  <button type="button" class="btn btn-info btn-sm" [disabled]="processingDonationReport" (click)="createDonationReport()">
    {{ processingDonationReport ? 'Processing Donation Report' : 'Create Donation Report' }}
    <span *ngIf="processingDonationReport">&nbsp;<i class="fas fa-spinner fa-pulse fa-fw"></i></span>
  </button>
  <span *ngIf="donationReportDocument">
    &nbsp;
    <span class="text-muted font-italic">Report:&nbsp;</span>
    <a [href]="'/documents/' + donationReportDocument.id + '/download'">{{ donationReportDocument.name }}</a>
  </span>
</div>
